export enum FontWeight {
    Light = 'light',
    Regular = 'regular',
    Medium = 'medium',
    SemiBold = 'semiBold',
    Bold = 'bold',
}
